<template>
	<div class="c-contact" :class="'c-contact--' + variant + ' c-contact--' + method + ' ' + (variant === 'footer' ? 's-light' : '')">
		<div class="c-contact__icon">
			<v-icon :name="iconName" size="s" />
		</div>
		<template v-if="variant === 'page'">
			<div class="c-contact__wrapper">
				<div class="c-contact__heading-and-text">
					<p class="c-contact__heading">{{heading}}</p>
					<p class="c-contact__text">{{text}}</p>
				</div>
				<p class="c-contact__link" v-if="method === 'chat'">
					<a class="c-button c-button--noboxshadow c-button--icon" :class="{ 'c-button--primary c-button--border-blue-medium': variant === 'page' }" :href="link">
						<span class="c-button--right">{{linkText}}</span>
						<v-icon name="icon-arrow" size="xxs" />
					</a>
				</p>
				<p class="c-contact__link" v-else>
					<a :href="link">{{linkText}}</a>
				</p>
			</div>
		</template>
		<template v-else>
			<div class="c-contact__wrapper">
			<div class="c-contact__heading-and-text">
				<p class="c-contact__heading">{{heading}}</p>
				<dt class="c-contact__text" v-if="method === 'adress'">
					<p>MKB Fastighets AB</p>
					<p>Södra Förstadsgatan 47</p>
					<p>Box 504 05</p>
					<p>202 14 Malmö</p>
				</dt>
				<p class="c-contact__text" v-else>{{text}}</p>
			</div>
			<p class="c-contact__link" v-if="method === 'chat'">
				<a class="c-button c-button--noboxshadow c-button--icon" :class="{ 'c-button--primary c-button--border-blue-medium': variant === 'page' }" :href="link">
					<span class="c-button--right">{{linkText}}</span>
					<v-icon name="icon-arrow" size="xxs" />
				</a>
			</p>
			<p class="c-contact__link" v-else-if="link">
				<a :href="link" class="c-contact--action">{{linkText}}</a>
			</p>
		</div>
		</template>
	</div>
</template>

<script>
import VIcon from '../../../components/icon/VIcon.vue';

export default {
	name: 'VContact',
	components: {
		VIcon
	},
	props: {
		variant: {
			type: String,
			default: 'footer'
		},
		method: {
			type: String,
			default: 'call'
		},
		heading: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		link: {
			type: String,
			default: ''
		},
		linkText: {
			type: String,
			default: ''
		},
		iconName: {
			type: String,
			default: ''
		}
	}
}
</script>
